import * as d3 from "d3";
import { TweenLite, TimelineLite, Power2, Back, Linear } from "gsap/all";
import DrawSVGPlugin from "../vendor/DrawSVGPlugin";
import { isMobile, getComputedTranslateXY } from "./config";
const cloudDuration = 90;
const C = DrawSVGPlugin;
const segmentDuration = 2;
const start = 0.8;
const gap = 3;

export default class Animation {
  constructor(maproot) {
    this.maproot = maproot;
    this.moveClouds = this.moveClouds.bind(this);
    this.showEverything = this.showEverything.bind(this);
    this.counter = 0;
    this.tl = new TimelineLite();
  }

  start = function() {
    const maproot = this.maproot;
    const animateIn = this.animateIn;
    const showEverything = this.showEverything;

    // const clouds = maproot.select('#CLOUDS');
    const line1 = maproot.select("#LINE1");
    const line4 = maproot.select("#LINE4");
    const line6 = maproot.select("#LINE6");
    const line9 = maproot.select("#LINE9");
    const line5 = maproot.select("#LINE5");
    const line7 = maproot.select("#LINE7");
    const line_1962 = maproot.select("#LINE_x5F_1962");

    const line_1965 = maproot.select("#LINE_x5F_1965");
    const line_1966 = maproot.select("#LINE_x5F_1966");

    const line_1968 = maproot.select("#LINE_x5F_1968");
    const line_1969 = maproot.select("#LINE_x5F_1969");

    const line13 = maproot.select("#LINE13");
    const line_1970 = maproot.select("#LINE_x5F_1970_2_");
    const line_1975 = maproot.select("#LINE_1975");
    const line_1972 = maproot.select("#LINE_x5F_1972");

    const line_1973 = maproot.select("#LINE_x5F_1973");
    const line_1974 = maproot.select("#LINE_x5F_1974");

    const line_1977 = maproot.select("#LINE_x5F_1977");
    const line_1979_2 = maproot.select("#LINE_x5F_1979_x5F_2");
    const line_1978 = maproot.select("#LINE_x5F_1978");
    const line_1979 = maproot.select("#LINE_x5F_1979");

    const line_1980 = maproot.select("#LINE_x5F_1980_1_");
    const line_1981 = maproot.select("#LINE_x5F_1981");
    const line_1982 = maproot.select("#LINE_1982");

    const line_1983 = maproot.select("#LINE_x5F_1983");
    // const line_1984 = maproot.select("#LINE_x5F_1984");
    const line_1989 = maproot.select("#LINE_x5F_1989");

    const line_1990 = maproot.select("#LINE_x5F_1990");
    const line_1991 = maproot.select("#LINE_x5F_1991");
    const line_1992 = maproot.select("#LINE_x5F_1992");
    const line_1993 = maproot.select("#LINE_x5F_1993");
    const line_1995 = maproot.select("#LINE_x5F_1995");

    const line_2000 = maproot.select("#LINE_x5F_2000");
    const line_2005 = maproot.select("#LINE_x5F_2005");

    const line_2010 = maproot.select("#LINE_x5F_2010");

    const map = document.getElementById("map_container");

    maproot.selectAll("#DESCRIPTIONS > g").style("opacity", 0);
    maproot.selectAll("#ENGINES > g").style("opacity", 0);
    maproot.selectAll("#CONTRAILS_BLUE > g").style("opacity", 0);

    this.tl.add(TweenLite.set("#map_container", { x: 0 }));
    // this.tl.add(TweenLite.delayedCall(13, this.showEverything));

    this.tl.add(
      TweenLite.to("#map_container", 2 * start, {
        x: -(map.offsetWidth - window.innerWidth - 120) / 2 - 100,
        ease: Linear.easeNone,
        rotation: 0.01,
        perspective: 1000,

        onComplete: function() {
          TweenLite.to("#map_container", 2 * start, {
            x: -(map.offsetWidth - window.innerWidth - 120),
            ease: Linear.easeNone,
            delay: 8.5,
            onComplete: function() {
              TweenLite.to("#map_container", 1, {
                x: 0,
                ease: Power2.easeInOut,
                delay: 6
              });
            }
          });
        }
      }),
      5
    );

    // this.tl.add(
    //   TweenLite.to("#map_container", 1, {
    //     x: 0,
    //     ease: Power2.easeInOut
    //   })
    // );
    // "#TURBOSUPERCHARGER-2"
    animateIn(["#TURBOSUPERCHARGER", "#TURBOSUPERCHARGER_1_"], "engine", 0.1);

    animateIn(line1, "lines", 0);

    animateIn(
      [
        "#Whittle_Engine",
        "#J-31",
        "#T-31",
        "#GE_I-A",
        "#Multiple_WWII_Aircraft_Used_GE_Thurbosuperchargers",
        "#Multiple_x5F_txt",
        "#Whittle",
        "#T-31_1_",
        "#J-31_1_",
        "#GE_I-A_1_"
      ],
      "planes",
      0.3
    );
    animateIn(
      ["#J33_Turbojet", "#J35", "#J-33_Turbojet", "#J-35"],
      "engine",
      1
    );

    animateIn(line4, "lines", 1);

    animateIn(
      [
        "#J47_Augmented_Turbojet",
        "#J73",
        "#J-73",
        "#J47",
        "#J-47",
        "#J-47_x0D_Augmented_x0D_Turbojet"
      ],
      "planes",
      1.2
    );

    // this.tl.add(TweenLite.to('#map_container',1,{x:-800}))
    /*****  1950      ******/

    animateIn(line6, "lines", 2.2);

    animateIn(["#GOL-1590", "#GOL-1590_1_"], "engines", 2.2);

    animateIn(["#J79", "#CJ805-3", "#J97_3_", "#CJ805-3_1_"], "planes", 2.2);

    animateIn(["#J93", "#CJ805-23", "#CJ805-23_1_", "#J93_1_"], "planes", 2.8);

    animateIn(line9, "lines", 2.7);

    animateIn(["#J85_Missile", "#J85_x5F_Missile"], "planes", 2.7);

    animateIn(
      [
        "#J85_Turbojet",
        "#J85_Augmented_Turbojet",
        "#CF700",
        "#CF700_1_",
        "#CJ610_1_",
        "#CJ610",
        "#J85_Turbojet_1_",
        "#J85_x03_Augmented_Turbojet_1_"
      ],
      "planes",
      2.7
    );
    animateIn(["#T58_Turboshaft", "#T58_Turboshaft_1_"], "engines", 2.5);

    animateIn(line7, "lines", 2.5);
    animateIn(["#T64", "#T64_2_"], "planes", 2.6);

    animateIn(
      ["#CT58_Turboshaft", "#CT58_Turboshaft_1_", "#LM100", "#LM100_1_"],
      "planes",
      2.5
    );

    animateIn(["#LM1500", "#LM1500_1_"], "planes", 2.6);

    animateIn(line5, "lines", 2.7);

    animateIn(["#T64_Turboprop", "#T64_Turboprop_1_"], "engines", 2.7);

    animateIn(["#CT64_Turboprop", "#CT64_Turboprop_1_"], "planes", 2.7);

    /*****  1960      ******/

    animateIn(line13, "lines", 4, 1);

    animateIn(["#GE1", "#GE1_1_"], "engines", 4);

    // this.tl.add(TweenLite.to('#map_container',1,{x:-1600}),'+=.2')

    animateIn(["#Ge1_x2F_6", "#GE1_x2F_6"], "engine", 4.5);
    animateIn(line_1965, "lines", 4.6);
    animateIn(["#T39_Turbofan", "#T39_Turbofan_1_"], "planes", 4.8);
    animateIn(line_1966, "lines", 4.6, 1);
    animateIn(line_1962, "lines", 4.8);
    animateIn(["#J97_1_", "#J97_2_"], "planes", 4.4);

    animateIn(line_1968, "lines", 5);
    animateIn(["#GE9", "#GE9_1_"], "planes", 5.1);
    animateIn(line_1973, "lines", 5.1, 2);
    animateIn(["#F101", "#F101_1_"], "planes", 5.4);
    animateIn(["#CFM56-2", "#CFM56-2_1_"], "planes", 5.4);
    animateIn(["#CFM56-3", "#CFM56-3_1_"], "planes", 5.8);
    animateIn(
      ["#TF34-400", "#TF34-400_1_"],
      "engines",

      5.4
    );

    animateIn(line_1969, "lines", 5.4, 1.5);
    animateIn(["#TF34-100", "#TF34-100_1_"], "planes", 5.6);

    animateIn(["#CF34-1", "#CF34-1_1_"], "planes", 5.8);
    animateIn(["#Cf6-6", "#CF6-6"], "planes", 5);
    animateIn(["#CF6-50", "#CF6-50_1_"], "planes", 5.1);
    animateIn(line_1978, "lines", 5.1, 2);
    animateIn(["#CF6-80A", "#CF6-80A_1_"], "planes", 5.4);
    animateIn(
      ["#CF6-80E1", "#CF6-80E1_1_", "#CF6-80C2", "#CF6-80C2_1_"],
      "planes",
      5.7
    );
    animateIn(line_1970, "lines", 5.8, 2);
    animateIn(
      ["#T700-700", "#T700-700_1_", "#LM500", "#LM500_1_"],
      "planes",
      6
    );
    animateIn(["#T700-701", "#T700-701_1_"], "planes", 6.2);

    animateIn(["#LM2500", "#LM2500_1_"], "planes", 5.4);

    animateIn(line_1972, "lines", 6.5, 1);
    animateIn(["#F110-100", "#F110-100_1_"], "planes", 6.8);
    animateIn(["#F110-400", "#F110-400_1_"], "planes", 7.1);

    animateIn(["#J101", "#J101_1_"], "planes", 6.8);

    animateIn(line_1974, "lines", 6.8);
    animateIn(["#F414", "#F414_1_"], "planes", 7);
    animateIn(["#M601", "#M601_1_"], "planes", 6.7);
    animateIn(["#LM2500", "#LM2500_1_"], "planes", 6.7);
    animateIn(["#F118", "#F118_1_"], "planes", 8);

    animateIn(line_1977, "lines", 7);
    animateIn(["#F404-F1D2", "#F404-F1D2_1_"], "planes", 7.3);

    animateIn(["#F404", "#F404_1_"], "planes", 7);

    animateIn(["#GE12", "#GE12_x5F_1_x5F_"], "engines", 5.8, 1);
    // animateIn(["#Cf6-6", "#CF6-6"], "engines", 3.7 + gap);
    animateIn(["#CT7-2A", "#CT7-2A_1_"], "planes", 6);
    animateIn(line_1979, "lines", 6, 2);
    animateIn(["#CT7-5_x2F_-7", "#CT7-5_x2F_-7_1_"], "planes", 6.2);
    animateIn(["#Ct7-9", "#CT7-9"], "planes", 6.5);

    animateIn(["#CT7-6", "#CT7-6_1_", "#LM1600", "#LM1600_1_"], "planes", 7);

    /*****  1970      ******/

    animateIn(
      ["#LM5000", "#LM5000_1_"],
      "planes",

      4.1 + gap
    );

    animateIn(["#F101", "#F101_1_"], "planes", 4 + gap);

    animateIn(line_1975, "lines", 7 + gap, 2);

    animateIn(["#GE30_E3", "#GE30_E3_1_"], "engines", 4.7 + gap);

    animateIn(line_1979_2, "lines", 4.7 + gap);

    /*****  1980      ******/

    // animateIn(["#CFM56-3", "#CFM56-3_1_"], "planes", 4.6 + gap);
    animateIn(["#Cfm56-5", "#CFM56-5"], "planes", 5.2 + gap);

    animateIn(line_1980, "lines", 4.7 + gap);

    animateIn(line_1981, "lines", 5.1 + gap);

    animateIn(["#T700-401", "#T700-401_1_"], "planes", 5.1 + gap);

    animateIn(line_1982, "lines", 5.2 + gap);
    animateIn(line_1983, "lines", 5.3 + gap);
    animateIn(["#GE27", "#GE27_1_"], "engines", 5.3 + gap);

    animateIn(["#CFE738", "#CFE738_1_"], "planes", 5.3 + gap);
    animateIn(["#F110-129", "#F110-129_1_"], "planes", 5.5 + gap);
    // animateIn(line_1978_2, "lines", 5.5 + gap);

    // animateIn(line17, ["#GE27"], ["#CFE738","#CFE738_1_","#GE38-1B","#GE38-1B_1_"]);
    animateIn(["#CF34-3", "#CF34-3_1_"], "planes", 5.4 + gap);

    // CT34-3
    animateIn(line_1989, "lines", 5.9 + gap);

    /***** 1990 */
    animateIn(["#T700-701C", "#T700-701C_1_"], "planes", 5.6 + gap);

    animateIn(["#T700-701D", "#T700-701D_1_"], "planes", 7.4 + gap);
    animateIn(line_2005, "lines", 7.4 + gap);

    animateIn(["#GE90-76B", "#GE90-76B_1_"], "planes", 7.2 + gap);

    animateIn(line_1990, "lines", 6 + gap);
    animateIn(["#CFM56-7", "#CFM56-7_1_"], "planes", 5.8 + gap);
    animateIn(line_1995, "lines", 7 + gap);

    animateIn(line_1992, "lines", 6.5 + gap);
    // animateIn(line_1993, "lines", 6.3);
    animateIn(["#F118-101", "#F118-101_1_"], "planes", 6.5 + gap);

    animateIn(["#GE90-94B", "#GE90-94B_1_"], "planes", 6.7 + gap);
    animateIn(["#CF34-8", "#CF34-8_1_"], "planes", 6.8 + gap);

    animateIn(
      [
        "#LM6000",
        "#LM6000_1_",
        "#LM2500_x2B",
        "#LM2500_x2B_",
        "#LM2500_x5F_",
        "#LM6000",

        "#GE90-76B",
        "#GE90-76B_1_"
      ],
      "planes",
      5.3 + gap
    );
    // animateIn(line_1991, "lines", 6);
    // animateIn(line_1992, "lines", 6);
    // animateIn(line_1993, "lines", 6);

    animateIn(["#T700-700k", "#T700-700k_1_"], "planes", 6.1 + gap);

    animateIn(["#LMS100", "#LMS100_1_"], "planes", 7.5 + gap);
    animateIn(["#LM2500_x2B_G4", "#LM2500_x2B_G4_1_"], "planes", 7.5 + gap);
    animateIn(["#LM6000_Growth", "#LM6000_Growth_1_"], "planes", 7.7 + gap);
    animateIn(["#t700_x2F_700k", "#T700_x5F_700K"], "planes", 7.7 + gap);

    animateIn(line_2000, "lines", 7 + gap, 1.5);
    animateIn(["#CT7-8", "#CT7-8_1_"], "planes", 6.7 + gap);
    animateIn(["#CF34-10", "#CF34-10_1_"], "planes", 7 + gap);
    animateIn(["#F110-132", "#F110-132_1_"], "planes", 7 + gap);
    animateIn(["#GE90-115B", "#GE90-115B_1_"], "planes", 7 + gap);
    animateIn(line_1991, "lines", 6.5 + gap);
    animateIn(["#GP7200_1_", "#GP7200"], "planes", 7.2 + gap);

    animateIn(
      ["#GEnx", "#GEnx-2", "#GEnx-2_1_", "#GEnx_1_"],
      "planes",
      7.8 + gap
    );

    animateIn(["#HF118", "#HF118_1_"], "planes", 7.3 + gap);
    animateIn(["#HF120", "#HF120_1_"], "planes", 7.6 + gap);

    animateIn(["#H80", "#H80_1_"], "planes", 7.9 + gap);
    animateIn(["#GE38-1B", "#GE38-1B_1_"], "planes", 7.9 + gap);

    animateIn(line_2010, "lines", 8 + gap, 1.5);

    animateIn(
      ["#T901", "#T901_1_", "#XA100", "#XA100_1_", "#CATALYST"],
      "engines",
      8.8 + gap
    );
    animateIn(["#F414-39E", "#F414-39E_1_"], "planes", 8.6 + gap);
    animateIn(["#F414-400", "#F414-400_1_"], "planes", 8.9 + gap);

    animateIn(
      [
        "#LEAP-1A",
        "#LEAP-1A_1_",
        "#LEAP-1B",
        "#LEAP-1B_1_",
        "#LEAP-1C",
        "#LEAP-1C_1_"
      ],
      "planes",
      8.9 + gap
    );

    animateIn(["#Passport_20", "#PASSPORT_x5F_20"], "planes", 9 + gap);

    animateIn(["#GE9X", "#GE9X_1_"], "planes", 9 + gap);

    animateIn(["#CT7-2E1", "#CT7-2E1_1_"], "planes", 8.9 + gap);

    this.tl.add(function() {
      showEverything();
    }, "-=.25");

    // animateIn(line20, [],['#HF118',"#HF118_1_","#HF120_1_",'#HF120']);
    // animateIn(line21);
    // animateIn(line22);

    // TweenLite.to('#map_container', 1, {
    //   x: -900,
    //   ease: Linear.easeNone,
    //   delay: 10
    // });
    // const showEverything = this.showEverything;
    this.tl.play();
  };

  animateIn = (nodes, type, delay, lineAnimLength) => {
    const tl = this.tl;
    // const engine_label = "engine" + this.counter;
    const interval = start * delay * segmentDuration;

    if (type === "engine" || type === "engines") {
      TweenLite.set(nodes, { opacity: 1 });
      nodes.forEach(node =>
        tl.add(
          TweenLite.from(node, 0.3, {
            scale: 0,
            x:
              d3
                .select(node)
                .node()
                .getBBox().width / 2,
            y:
              d3
                .select(node)
                .node()
                .getBBox().height / 2,
            ease: Back.easeOut
          }),
          interval
        )
      );
    }

    if (type === "planes") {
      tl.add(
        TweenLite.set(nodes, {
          opacity: 1
        }),
        interval
      );
    }
    //Animate lines in
    if (type === "lines") {
      TweenLite.set(nodes.node(), { opacity: 1 });
      nodes.selectAll("*").each(function(d, i) {
        const line = d3.select(this).node();
        tl.add(
          TweenLite.from(line, lineAnimLength || 0.75, {
            drawSVG: 0
          }),
          interval + i * 0.1
        );
      });
    }
    //Animate rest of group planes
  };

  pause() {
    this.tl.pause();
  }

  skip() {
    const lineDuration = this.tl.duration();
    TweenLite.killTweensOf("#map_container");
    this.tl.seek(lineDuration, false);

    // this.showEverything();
  }

  replay() {
    this.maproot.selectAll("#DESCRIPTIONS > g").style("opacity", 0);
    // // this.maproot.selectAll("#ENGINES > g").style("opacity", 0);
    // this.maproot.selectAll("#CONTRAILS_BLUE > g").style("opacity", 0);
    TweenLite.killTweensOf(document.getElementById("CLOUDS"));
    this.tl.restart();
  }

  showEverything() {
    // alert('showing');
    const maproot = this.maproot;
    maproot
      .selectAll("#ENGINES > g")
      .transition()
      .duration(750)
      .style("opacity", 1);
    maproot
      .selectAll("#CONTRAILS_BLUE > g")
      .transition()
      .duration(750)
      .style("opacity", 1);
    maproot
      .selectAll("#DESCRIPTIONS > g")
      .transition()
      .duration(750)
      .style("opacity", 1);
    if (!isMobile()) this.moveClouds();
    // TweenLite.to('#map_container', 2, { scale: 1, ease: Power2.easeOut });
  }

  moveClouds() {
    // console.log("yo");
    // alert("ow");
    const clouds = document.getElementById("CLOUDS2");
    // console.log(getComputedTranslateXY(clouds));
    if (getComputedTranslateXY(clouds)[0] < -3000) {
      TweenLite.set("#CLOUDS2", { x: 2600 });
    }

    // if
    TweenLite.to("#CLOUDS2", cloudDuration, {
      x: "-=200",
      ease: Linear.easeNone,
      onComplete: this.moveClouds
    });
  }
}
